module.exports = __webpack_public_path__ + "img/31.950f5179.png";